<template>
  <div>
    <vs-popup :title="$t('CurrencyType')" :active.sync="showModal">
      <div class="vx-row mb-6">
        <div class="vx-col w-full my-2">
          <label class="vs-select--label my-1">{{
            $t("SourceCurrency")
          }}</label>

          <v-select
            class="m-0"
            label="name"
            name="currencyType"
            :options="currencyTypes"
            v-model="model.currencyType"
            :reduce="(x) => x.id"
            dir="rtl"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('currencyType')"
            >{{ errors.first("currencyType") }}</span
          >
        </div>
        <!-- <div class="vx-col w-full my-2">
          <label class="vs-select--label my-1">{{
            $t("TargetCurrency")
          }}</label>

          <v-select
            class="m-0"
            label="name"
            name="TargetCurrencyType"
            :options="currencyTypes"
            v-model="model.targetCurrencyType"
            :reduce="(x) => x.id"
            dir="rtl"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('TargetCurrencyType')"
            >{{ errors.first("TargetCurrencyType") }}</span
          >
        </div> -->
        <div class="vx-col w-full my-2">

          <vs-input v-model="model.rate" name="rate" :label="$t('Rate')" type="number"/>
          <span class="text-danger text-sm" v-show="errors.has('rate')">{{
            errors.first("rate")
          }}</span>
        </div>

        <div class="flex justify-end w-full ml-5">
          <vs-button
            type="filled"
            class="mb-4 mt-4"
            @click.prevent="submitForm"
            :disabled="!model.currencyType || !model.rate"
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<style lang="scss">
body[dir="rtl"] .vs-popup--content {
  overflow-y: scroll !important;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    // TargetCurrencyType: {
    //   required: "لطفا ارز مقصد را وارد نمایید.",
    // },
    currencyType: {
      required: "لطفا ارز مبدا را وارد نمایید.",
    },
    bPrice: {
      required: "لطفا نرخ را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);

export default {
  components: {
    "v-select": vSelect,
  },
  props: {
    show: { default: false },
  },
  data() {
    return {
      departman: "",
      popupTitle: "",
      disabled: false,
      model: {},
      price: null,
      currencyTypes: [
        { name: "ریال", id: 1 },
        { name: "دلار", id: 2 },
        { name: "درهم", id: 3 },
      ],
    };
  },
  computed: {
    showModal: {
      get: function () {
        this.model.purchaseInvoiceId = this.$route.params.id;

        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createAccount: "purchaseInvoice/saveCurrencyType",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createAccount(this.model).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
              showConfirmButton: false,
              timer: 2000,
            });

            this.$emit("finish");
            this.model = {};
            this.price = null;
          });
        } else {
          // form have errors
        }
      });
    },
  },
  // watch: {
  //   show() {
  //     if (this.show == true) {
  //       this.price = this.model.rate.toLocaleString();
  //     }
  //     this.$validator.reset();
  //   },
  //   price(value) {
  //     if (value) {
  //       var n = parseFloat(value.replace(/,/g, ""), 10);
  //       this.price = n.toLocaleString();
  //       this.model.rate = this.price.replace(/,/g, "");
  //     } else {
  //       this.price = null;
  //       this.model.rate = null;
  //     }
  //   },
  // },
};
</script>
